/* === NEW FILE: src/pages/admin/AdminLiveCourseRegistrationsModal.js === */
import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const AdminLiveCourseRegistrationsModal = ({ courseId, onCancel }) => {
    const [registrations, setRegistrations] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchRegistrations = useCallback(async () => {
        setIsLoading(true);
        try {
            const token = localStorage.getItem('app_token');
            const response = await axios.get(`/api/admin/live-courses/${courseId}/registrations`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setRegistrations(response.data);
        } catch (err) {
            setError('Failed to load registered users.');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    }, [courseId]);

    useEffect(() => {
        fetchRegistrations();
    }, [fetchRegistrations]);

    return (
        <div className="admin-modal-overlay nested-modal-overlay">
            <div className="admin-modal-content" style={{ maxWidth: '800px' }}>
                <h2>Registered Users</h2>
                {isLoading ? <p>Loading...</p> : error ? <p className="error-message">{error}</p> : (
                    <div className="admin-table-container">
                        <table className="admin-table">
                            <thead>
                                <tr>
                                    <th>User</th>
                                    <th>Email</th>
                                    <th>Registration Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {registrations.length > 0 ? registrations.map((reg, index) => (
                                    <tr key={index}>
                                        <td>
                                            <div className="user-cell">
                                                <img src={reg.profile_picture} alt={reg.name} className="user-avatar" />
                                                <span className="user-name">{reg.name}</span>
                                            </div>
                                        </td>
                                        <td>{reg.email}</td>
                                        <td>{new Date(reg.registration_date).toLocaleDateString()}</td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="3" style={{ textAlign: 'center' }}>No users have registered for this course yet.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
                <div className="form-actions">
                    <button type="button" onClick={onCancel} className="btn-secondary">Close</button>
                </div>
            </div>
        </div>
    );
};

export default AdminLiveCourseRegistrationsModal;
